export default __webpack_public_path__ + "static/media/FavIcon.bd705dc3.svg";